import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import {StepConfig} from '~/QuickEcards/types/misc';
import {getCurrentStep, stepMeta, getLastPathComponent} from '~/QuickEcards/utils/navigation';

type CurrentRouteDetails = {
  currentRoute: StepConfig | null;
  isUnsavedCreateStep: boolean;
};

export const useCurrentRoute = (): CurrentRouteDetails => {
  const location = useLocation();
  const currentStep = getCurrentStep();

  const config = useMemo(() => {
    const lastPathComponent = getLastPathComponent(location.pathname);

    if (!currentStep) {
      return {
        currentRoute: null,
        isUnsavedCreateStep: false,
      };
    }
    return {
      currentRoute: {
        ...currentStep,
        path: currentStep.path || lastPathComponent,
        meta: stepMeta,
      },
      isUnsavedCreateStep: currentStep.path === 'create',
    };
  }, [currentStep, location.pathname]);

  return config;
};
